import _jsx from "@babel/runtime/helpers/jsx";
var _Fragment, _Fragment2, _Fragment3, _Fragment4;
import PropTypes from 'prop-types';
import React from 'react';
import { SubHeading, Text } from 'reaxl';
import SelectableInventorySnapshot from '../SelectableInventorySnapshot';
function EmailAdditionalInventory(_ref) {
  let {
    additionalInventoryInfo = {},
    handleListingSelect = () => {}
  } = _ref;
  const additionalInventory = additionalInventoryInfo?.listings;
  if (!additionalInventory?.length) return null;
  const {
    hasSavedListings
  } = additionalInventoryInfo;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(SubHeading, {
    className: "margin-bottom-3",
    size: 400
  }, void 0, hasSavedListings ? _Fragment || (_Fragment = /*#__PURE__*/React.createElement(React.Fragment, null, "Follow Up On Your Saved Vehicles")) : _Fragment2 || (_Fragment2 = /*#__PURE__*/React.createElement(React.Fragment, null, "Still thinking? Don't leave your recently viewed vehicles in the dust."))), /*#__PURE__*/_jsx(Text, {}, void 0, hasSavedListings ? _Fragment3 || (_Fragment3 = /*#__PURE__*/React.createElement(React.Fragment, null, "Let the sellers know you're still interested and confirm availability.")) : _Fragment4 || (_Fragment4 = /*#__PURE__*/React.createElement(React.Fragment, null, "Check their availability with the dealer."))), /*#__PURE__*/_jsx("div", {
    className: "margin-vertical-2"
  }, void 0, additionalInventory?.map(listing => /*#__PURE__*/_jsx("div", {
    className: "row"
  }, `Selectableinventory_${listing.id}`, /*#__PURE__*/_jsx(SelectableInventorySnapshot, {
    listing: listing,
    onChange: e => handleListingSelect(e, listing)
  })))));
}
export default EmailAdditionalInventory;